// src/app/core/shared/loading.service.ts
// Minimal fix: prevent generic show() calls from overwriting a custom message while already loading.

import { Injectable, NgZone, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  private messageSubject = new BehaviorSubject<string>('Loading...');
  message$ = this.messageSubject.asObservable();

  private zone = inject(NgZone);

  show(message?: string) {
    this.zone.run(() => {
      if (this.isLoadingSubject.value) {
        if (message) this.messageSubject.next(message);
        return;
      }
      this.messageSubject.next(message ?? 'Loading...');
      this.isLoadingSubject.next(true);
    });
  }

  hide() {
    this.zone.run(() => {
      this.isLoadingSubject.next(false);
      this.messageSubject.next('Loading...');
    });
  }
}